<template>
   <div >

      <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
      <!--</div>-->

      <Section
          background="black"
          class="image-bg"

      >
         <!--       :style="{'background-image': `url(${require('../assets/images/content/background_math2.png')})`}"-->

         <div style="width:100%">
            <nav-bar ></nav-bar>
         </div>


<!--         <div class="main-heading">-->
<!--            <div class="heading-line">-->
<!--               <div class="center  pt-0" style="font-size: 39pt; font-weight: 400">-->
<!--                  Advizer Pricing-->
<!--               </div>-->
<!--               -->
<!--            </div>-->
<!--         </div>-->

      </Section>




      <Section background="white" class="" style="background-color: #ded5f1;">


         <div style="color: black">
            <div class="main-heading">
               <div class="heading-line">
                  <div class="center  pt-0" style="font-size: 39pt; font-weight: 400">
                     Advizer Pricing
                  </div>

               </div>
            </div>


            <div style="display:flex; justify-content: center">
               <div class="pricing-column-container">

                  <div class="pricing-column">
                     <div class="pricing-header">
                        <h3>Month to Month</h3>
                     </div>

                     <div class="pricing-body">
                        <p class="pricing-text-centered pt-3">
                           No Commitment, No Risk
                        </p>

                        <div class="divider"></div>

                        <div class="pricing-text-centered pricing-box-size pt-3">

                           <div class="price-container">
                              <span class="price">$695</span>
                              <div class="per-unit-text">
                                 <p>per month</p>
                                 <p>per dealership</p>
                              </div>
                           </div>

                           <p class="pt-2">Monthly Contract</p>
                           <p class="price-setup"> Setup Fee: $1,500</p>
                        </div>

                        <div class="divider"></div>
                        <div class="price-description">
                           <div class="button-container">
                              <v-btn to="/contact" color="var(--color-primary)" rounded>
                                 Contact Us To Signup
                              </v-btn>
                           </div>


                           <ul>
                              <li>Cancel Service Anytime</li>
                              <li>90 Day Money-Back Guarantee<br>
                                 <div class="mbg-small">
                                    Cancel in the first 60 days and the only thing you'll owe us is the setup fee of $1,500.
                                 </div>
                              </li>
                           </ul>
                        </div>


                     </div>
                  </div>

                  <div class="pricing-column">
                     <div class="pricing-header">
                        <h3>6 Month Contract</h3>
                     </div>

                     <div class="pricing-body">
                        <p class="pricing-text-centered pt-3">
                           A Little Commitment, No Risk
                        </p>

                        <div class="divider"></div>

                        <div class="pricing-text-centered pricing-box-size pt-3">

                           <div class="price-container">
                              <span class="price">$595</span>
                              <div class="per-unit-text">
                                 <p>per month</p>
                                 <p>per dealership</p>
                              </div>
                           </div>

                           <p class="pt-2">Six Month Contract</p>
                           <p class="price-setup"> Setup Fee: <span class="cross-out"> $1,500</span> $0</p>
                        </div>

                        <div class="divider"></div>
                        <div class="price-description">
                           <div class="button-container">
                              <v-btn to="/contact" color="var(--color-primary)" rounded>
                                 Contact Us To Signup
                              </v-btn>
                           </div>
                           <ul>
                              <li>Cancel With 60 Day Notice</li>
                              <li>Group Discounts Available</li>
                              <li>90 Day Money-Back Guarantee<br>
                                 <div class="mbg-small">
                                 Cancel in the first 90 days and the only thing you'll owe is the undiscounted setup fee of $1,500.
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>

                  <div class="pricing-column">
                     <div class="pricing-header">
                        <h3>12 Month Contract</h3>
                     </div>

                     <div class="pricing-body">
                        <p class="pricing-text-centered pt-3">
                           More Commitment,  Still No Risk
                        </p>

                        <div class="divider"></div>

                        <div class="pricing-text-centered pricing-box-size pt-3">

                           <div class="price-container">
                              <span class="price">$495</span>
                              <div class="per-unit-text">
                                 <p>per month</p>
                                 <p>per dealership</p>
                              </div>
                           </div>

                           <p class="pt-2">Annual Contract</p>
                           <p class="price-setup"> Setup Fee: <span class="cross-out"> $1,500</span> $0</p>
                        </div>

                        <div class="divider"></div>
                        <div class="price-description">
                           <div class="button-container">
                              <v-btn to="/contact" color="var(--color-primary)" rounded>
                                 Contact Us To Signup
                              </v-btn>
                           </div>
                           <ul>
                              <li>Cancel With 60 Day Notice</li>
                              <li>Group Discounts Available</li>
                              <li>90 Day Money-Back Guarantee<br>
                                 <div class="mbg-small">
                                 Cancel in the first 90 days and the only thing you'll owe is the undiscounted setup fee of $1,500.
                                 </div>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>


<!--                  <div class="pricing-column">-->
<!--                     <div class="pricing-header">-->
<!--                        <h3>Groups/Custom Pricing</h3>-->
<!--                     </div>-->

<!--                     <div class="pricing-body">-->
<!--                        <p class="pricing-text-centered pt-3">-->
<!--                           Let's talk, We're Flexible-->
<!--                        </p>-->

<!--                        <div class="divider"></div>-->

<!--                        <div class="pricing-text-centered pricing-box-size pt-3">-->

<!--                           <div class="price-container pt-4">-->
<!--                              <span class="price">Call Us</span>-->
<!--                           </div>-->

<!--                        </div>-->

<!--                        <div class="divider"></div>-->
<!--                        <div class="price-description">-->
<!--                           <div class="button-container">-->
<!--                              <router-link to="/contact" class="button-accent">Contact Us To Signup</router-link>-->
<!--                           </div>-->
<!--                           <ul>-->
<!--                              <li>Let us know what your needs are and we'll build a custom pricing plan around them.</li>-->
<!--                           </ul>-->
<!--                        </div>-->
<!--                     </div>-->
<!--                  </div>-->

               </div>
            </div>







<!--            <div class="divider"></div>-->



            <h2 class="pb-3 pt-10 text-center">
               All Plans Include
            </h2>
            <div class="features">
               <div class="features-column">
                  <ul>
                     <li>Daily MTD Performance Analysis </li>
                     <li>Email/SMS Alerts</li>
                     <li>Diagnostic Engine </li>
                     <li>Data Integrations w/ Vendors</li>
                     <li>Custom Data Mapping</li>

                  </ul>
               </div>
               <div class="features-column">
                  <ul>
                     <li>Customizable Dashboard</li>
                     <li>Metric Tracking</li>
                     <li>Unlimited Users </li>
                     <!--<li>24/7 Access </li>-->
                     <li>Active Support </li>
                     <li>90 Day Money-Back Guarantee* </li>
                  </ul>
               </div>

               <p class="pt-4 pb-10" style="font-size: medium">
                  *Cancel within first 90 days of service and we'll
                  issue a full refund <span style="font-size:medium;">(excludes setup fees)</span>
               </p>
            </div>



         </div>







      </Section>











   </div>

</template>






<style scoped lang="scss">


.image-bg{
   background-size: cover;
   background-position: center;
}


.main-heading{
   height: 250px;
   display: flex;
   align-items: center;
   justify-content: center;

}

.heading-line{

   text-align: center;

}


.process-section{
   height: 700px;
   text-align: justify;

}



.bg-transparent-light{
   background: rgba(255, 255, 255, 0.05);
   width:100%;
}


.section-heading{
   font-size: 3em;
   padding-top: 10px;
   padding-bottom: 10px;
   width: 100%;
   text-align: center;

}


.section-sub-heading {
   font-size: 2em;
   font-weight: normal;
   width: 100%;
   text-align: center;
}



.container-services{
   max-width: 1200px;
   text-align: center;


   /*.service-heading{*/
   /*font-size: 2em;*/
   /*font-weight: normal;*/
   /*}*/

   .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
   }
}

.colored-icon-text{
   font-size: 1.4em;
   /*font-size: 1.0em;*/
   /*text-align: left;*/
   text-align: justify;
   max-width: 800px;
}







//***********settings for slider***************************


.slide-container{
   display: flex;
   align-items: center;
   justify-content: center;
   height: 100%;
   min-height: 800px;
}

.slide-content{
   margin: auto;
   padding-left: 20px;
   padding-right: 20px;
   max-width: 1000px;

}
.slide-spacer{
   flex: 'flex-grow';
}





//********settings for ease as 123 section***************

.numbered-item{
   display: block;
   text-align: left;
}


.numbered-line{
   display: flex;
   justify-content: flex-start;
   align-items: center;

}

.numbered-line-text{
   font-size: 17pt;
   font-weight: 500;
   margin-top: -7px;
   margin-left: 7px
}
.numbered-line-fine-print{
   //padding-left: 10px;
   margin-top: -5px;
   margin-left: 5px;
   font-size: 12pt;
   max-width: 450px;
}

//*******settings for why advizer ************************

.why-text{
   padding: 10px;
   font-size: 1.5em;
   font-weight: 200;
   max-width: 800px;
   text-align: justify;

}


//******features**************

.advizer-feature-container{
   padding-top: 20px;
   padding-bottom: 20px;

}
.advizer-feature-header{
   font-size: 20pt;
   font-weight: 500;
   padding-left: 10px;
}

.advizer-feature-text{
   font-size: 15pt;
}














//************pricing settings**************************************

.bg-transparent{
   position: relative;
   width: 100%;
   display: flex;
   flex-flow: column wrap;
   align-items: center;
   justify-content: center;
   padding-top: 60px;
   padding-bottom: 60px;
}



/*padding-bottom: 210px;*/

.pricing-container{

   padding-top: 30px;
   padding-bottom: 30px;
   padding-left: 10px;
   padding-right: 10px;
}


.particle-background {
   position: fixed;
   height: 100%;
   align-items: center;
   justify-content: center;
   width: 100%;
   z-index: 0;
}

.bg-transparent-dark0 {
   background: rgba(0, 0, 0, 0.1);
   color: rgb(255, 255, 255);
}
.header{
   margin-bottom: 20px;
}

.divider{
   width: 100%;
   border-top-style: solid;
   border-color: #d1d1d1;
   margin-bottom: 20px;
   margin-bottom: 10px;
   border-width: 1px;
}

.mbg-small{
   font-size: x-small !important;
   line-height: 120%;
   width: 90%;
}

.cross-out{
   text-decoration: line-through red;
}

.button-container{
   position: relative;
   bottom: 0px;
   display: flex;
   flex-flow: row nowrap;
   width: 100%;
   justify-content: center;
   align-items: center;
   margin-bottom: 20px;

   .button-accent{
      display: flex;
      border-radius: 20px;
      width: 220px;
      height: 40px;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: medium;
   }
}



.pricing-column-container{
   display: flex;
   flex-flow: row wrap;
   align-items: flex-start;
   //justify-content: flex-start;
   justify-content: space-evenly;
   width: 100%;
   max-width: 1300px;
}

.pricing-column{
   display: flex;
   flex-flow: column nowrap;
   align-items: flex-start;
   height: 500px;
   background-color: #ffffff;
   width: 300px;
   border-radius: 10px;
   //box-shadow: 7px 7px 10px grey;
   box-shadow: 7px 7px 10px #8b8b9b;
   margin-bottom: 30px;
   margin-left: 5px;
   margin-right: 5px;


   .pricing-header{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      color: #e7e7e7;

      width:100%;
      height: 70px;
      background-color: #7042c8;
      border-radius: 10px;

   }

   .pricing-body{
      display: flex;

      width: 100%;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      /*padding-top: 20px;*/
      /*padding-left: 30px;*/
      /*padding-right: 10px;*/
      text-align: left;
      font-size: large;
      border-radius: 0px;

      p{
         font-size: large;
      }

      .pricing-text{
         width: 100%;
         padding-left: 10px;
         padding-right: 10px;
      }

      .pricing-text-centered{
         width: 100%;
         padding-left: 10px;
         padding-right: 10px;
         text-align: center;
      }

      .pricing-box-size{
         height: 150px;
      }

      .price-setup{
         font-size: medium;
      }

      .price-container{
         display: flex;
         flex-flow: row nowrap;
         justify-content: center;
         align-items: center;
         width: 100%;

         .price{
            font-size: xx-large;
            color: #00c853;
         }

         .per-unit-text{
            padding: 0px;
            margin: 0px;
            margin-left: 10px;
            display: flex;
            flex-flow: column nowrap;
            p{
               font-size: small;
               text-align: left;
               padding: 0px;
               margin: 0px;
            }

         }
      }

      .price-description{
         font-size: medium;
         padding-top: 10px;
         padding-left: 10px;
         padding-right: 10px;
      }




      ul{
         padding-left: 30px;
         li{
            padding-bottom: 10px;
         }
      }
      /*ul{*/
      /*list-style-type: none;*/
      /*padding: 0;*/
      /*margin: 0;*/

      /*li::before{*/
      /*content: '';*/
      /*background: url('/images/icons/checked-button.svg') no-repeat left top;*/
      /*background-size: 20px 20px;*/
      /*!*display: block;*!*/
      /*height: 54px;*/
      /*width: 54px;*/
      /*padding-left: 44px;*/
      /*padding-top: 3px;*/
      /*padding-bottom: 3px;*/

      /*}*/
      /*}*/



   }
}

.features{
   display: flex;
   flex-flow: row wrap;
   justify-content: center;
   align-items: flex-start;
   font-size: x-large;
   .features-column{
      /*width: 500px;*/
      padding-left: 30px;
      padding-right: 30px;

   }

   ul{
      text-align: left;
      padding-left: 30px;
      li{
         /*padding-top: 20px;*/
         padding-bottom: 10px;
      }
   }
   /*ul{*/
   /*list-style-type: none;*/
   /*padding: 0;*/
   /*margin: 0;*/

   /*li::before{*/
   /*content: '';*/
   /*background: url('/images/icons/checked-button.svg') no-repeat left top;*/
   /*background-size: 20px 20px;*/
   /*!*display: block;*!*/
   /*height: 54px;*/
   /*width: 54px;*/
   /*padding-left: 44px;*/
   /*padding-top: 3px;*/
   /*padding-bottom: 3px;*/

   /*}*/
   /*}*/
}




</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'


export default {
   name: 'pricing',
   components: {navBar, Section, Contact, VueperSlides, VueperSlide},
   data(){return {
      slide_duration: 12,
      slides: [
         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product1.png'),
            comment: 'comment'

         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product2.png'),
            comment: 'comment'
         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product3.png'),
            comment: 'comment'

         },

         {
            title: 'screenshot1',
            img: require('../assets/images/tmp/product4.png'),
            comment: 'comment'

         },


         // {
         //    title: 'DealerKnows Training',
         //    content: 'The guys at Espy Data Science built a custom app for us under a very tight deadline and did a great job.  ' +
         //       'I look forward to working with them on future projects.',
         //    author: 'Bill, Founder'
         // },

      ]
   }},

   methods:{
      track (eventLabel, category='SiteNavigation') {
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      }
   },

   computed:{

      show_arrows(){
         if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
            return false;
         }
         else{
            return true;
         }
      },

      slide_ratio(){

         if (['xs'].includes(this.$vuetify.breakpoint.name)){
            return 0.7;
         }

         else if (['sm'].includes(this.$vuetify.breakpoint.name)){
            return 0.5;
         }
         else {
            return 0.3;
         }
      }
   },

   created(){
   }


}
</script>
